<template>
<!--  <el-popover-->
<!--    placement="right"-->
<!--    width="400"-->
<!--    style="margin-left: 5px"-->
<!--    trigger="click">-->
<!--    <el-form ref="formRef" :model="form" label-width="100px" label-position="right" class="custom-form">-->
<!--      <el-form-item label="付款金额" prop="fukuan">-->
<!--        <el-input v-model="form.fukuan" placeholder="请输入付款金额"></el-input>-->
<!--      </el-form-item>-->
<!--    </el-form>-->
<!--    <div slot="footer" class="dialog-footer">-->
<!--      <el-button @click="handleClose">取 消</el-button>-->
<!--      <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确 定</el-button>-->
<!--    </div>-->
<!--    <el-button slot="reference" size="small" type="warning">批量审核付款</el-button>-->
<!--  </el-popover>-->
  <el-button slot="reference" size="small" type="warning" style="margin-left: 5px;" @click="handleSubmit">批量审核付款</el-button>
</template>
<script>
import {defineComponent, reactive, ref} from "@vue/composition-api";
import useRootSetting from '@/hooks/useRootSetting'
import {Message} from "element-ui";
export default defineComponent({
  props: {
    showBatch: {
      type: Boolean,
      default: false
    },
    selectedIds: {
      type: [Array,Number],
      default: 0
    }
  },
  setup(props, {emit}) {
    const {getIsMobile} = useRootSetting()
    const formRef = ref(null)
    const form = reactive({
      fukuan: 'all',
    })
    const visible = ref(false)

    const handleSubmit = () => {
      if(props.selectedIds === 0) {
        Message.warning('批量操作至少选择一条数据！')
      }else{
        emit('submit', form,'batch')
      }
    }


    return {
      visible,
      formRef,
      form,
      handleSubmit,
    }
  }
})
</script>
